export const tableConfig = {
    name: 'history',
    selection: false,
    index: false,
    height: 300,
    columns: [
        {
            label: '变更类型',
            prop: 'updateType',
            type: 'select',
            optionsKey: 'CUSTOMER_UPDATE_TYPE'
        },
        {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            optionsKey: 'DB_OPERATE_TYPE'
        },
        {
            label: '关联变更单号',
            prop: 'customerChangeCode',
            width: 150
        },
        {
            label: '变更项目',
            prop: 'updateFieldCode',
            width: 150
        },
        {
            label: '变更项目名称',
            prop: 'updateFieldName',
            width: 150
        },
        {
            label: '变更前编码',
            prop: 'oldValue',
            width: 150
        },
        {
            label: '变更前名称',
            prop: 'oldValueName',
            width: 150
        },
        {
            label: '变更后编码',
            prop: 'newValue',
            width: 150
        },
        {
            label: '变更后名称',
            prop: 'newValueName',
            width: 150
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 150
        }
    ]
};
